import { css } from '@emotion/react'
import { Alert, Button, HFlow, Modal, ModalBody, ModalFooter, ModalHeader, Text, VFlow } from 'bold-ui'
import { TipoAtestadoEnum } from 'graphql/types.generated'

import { AtestadoContentBox } from '../components/AtestadoContentBox'
import { tituloAtestado } from '../utils-atestado'

interface AtestadoConfirmarAssinaturaDigitalModalProps {
  emailCidadao: string
  onConfirm: () => void
  onCancel: () => void
  isAssinando: boolean
  errorMessage?: React.ReactNode
  onAlertClose: () => void
  tipoAtestado: TipoAtestadoEnum
  descricao: string
}

export const AtestadoConfirmarAssinaturaDigitalModal = (props: AtestadoConfirmarAssinaturaDigitalModalProps) => {
  const { emailCidadao, onConfirm, onCancel, isAssinando, errorMessage, onAlertClose, tipoAtestado, descricao } = props

  return (
    <Modal onClose={onCancel} open depthLevel={2}>
      <ModalHeader
        title='Confira os dados do atestado'
        subtitle={
          <>
            Este atestado será assinado e enviado ao cidadão via e-mail, verifique atentamente os dados incluídos no
            documento.{' '}
            <strong>Após gerar e assinar um atestado digital não será possível editar ou excluir o registro.</strong>
          </>
        }
        icon={{ name: 'exclamationTriangleOutline', fill: 'alert' }}
      />
      <ModalBody>
        <VFlow vSpacing={2}>
          <VFlow vSpacing={0.5}>
            <HFlow>
              <div>
                <Text fontWeight='bold'>Enviar para: </Text>
                <Text>{emailCidadao}</Text>
              </div>
            </HFlow>
            {errorMessage && (
              <Alert inline type='warning' onCloseClick={onAlertClose}>
                {errorMessage}
              </Alert>
            )}
          </VFlow>
          <AtestadoContentBox
            title={tituloAtestado(tipoAtestado)}
            content={descricao}
            isContentRichText={tipoAtestado === TipoAtestadoEnum.EM_BRANCO}
            variant='modal'
          />
        </VFlow>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end'>
          <Button kind='normal' size='medium' onClick={onCancel} style={styles.buttons}>
            Cancelar
          </Button>
          <Button
            kind='primary'
            skin='default'
            size='medium'
            onClick={onConfirm}
            disabled={isAssinando}
            loading={isAssinando}
            style={styles.buttons}
          >
            Enviar
          </Button>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}

const styles = {
  buttons: css`
    min-width: 9rem;
  `,
}
